// extracted by mini-css-extract-plugin
module.exports = {"root":"FitBox_root__5wOX9","trigger":"FitBox_trigger__bht6p","description":"FitBox_description__Y_6LW"};